import React, { useState, useEffect } from 'react';
import BaseForm from '../../app/components/BaseForm';
import Select from '../../app/components/Select';

const FormAddMySequence = ({ isOpen, onClose, onSubmit, activeTab, departments }) => {
  const initialFormData = {
    departamento: '',
    nomeSequencia: '',
  };

  const [formData, setFormData] = useState(initialFormData);
  const [departamentoOptions, setDepartamentoOptions] = useState([]);

  useEffect(() => {
    const formatted = departments.map(dep => ({
      value: dep.nome,
      label: dep.nome
    }));
    setDepartamentoOptions(formatted);
  }, [departments]);

  useEffect(() => {
    if (!isOpen) {
      setFormData(initialFormData);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const handleClose = () => {
    setFormData(initialFormData);
    onClose();
  };

  const nomeSequenciaOptions = [
    { value: 'Apuração Fiscal', label: 'Apuração Fiscal' },
    { value: 'Abertura de Empresa', label: 'Abertura de Empresa' },
    { value: 'Análise Financeira', label: 'Análise Financeira' },
    { value: 'Processo Seletivo', label: 'Processo Seletivo' },
    { value: 'Desenvolvimento de Feature', label: 'Desenvolvimento de Feature' },
  ];

  const handleChange = (option, fieldName) => {
    if (option?.target) {
      setFormData((prev) => ({ ...prev, [fieldName]: option.target.value }));
    } else if (option?.value) {
      setFormData((prev) => ({ ...prev, [fieldName]: option.value }));
    } else {
      setFormData((prev) => ({ ...prev, [fieldName]: '' }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <BaseForm
      isOpen={isOpen}
      onClose={handleClose}
      onSubmit={handleSubmit}
      title="Nova Sequência"
      primaryColor="#52225a"
      submitButtonText="Salvar"
      cancelButtonText="Cancelar"
    >
      <div className="space-y-6">
        <div className="space-y-8">
          <div>
            <Select
              label="Selecione o departamento"
              name="departamento"
              value={formData.departamento}
              onChange={(val) => handleChange(val, 'departamento')}
              options={departamentoOptions}
            />
          </div>

          <div>
            <Select
              label="Selecione o nome da sua sequência"
              name="nomeSequencia"
              value={formData.nomeSequencia}
              onChange={(val) => handleChange(val, 'nomeSequencia')}
              options={nomeSequenciaOptions}
            />
          </div>
        </div>
      </div>
    </BaseForm>
  );
};

export default FormAddMySequence;
